'use client';

import { useNotification } from '@packages/shared/src/providers/NotificationProvider/useNotification';
import { usePathname } from 'next/navigation';
import { useIntl } from 'react-intl';
import { useSubscribeNewsletterGqlMutation } from '../helpers/useSubscribeNewsletterGqlMutation';
import { generalFormMessages } from '../messages';
import { subscribeSheetMessages } from './NewsletterSheet.messages';

/**
 * Content for the DOI-Notification, consisting of an info text and a clickable text
 * that requests another Confirmation Email.
 */
export const DoiNotificationContent = ({
  onClickedSuccess,
  email,
}: {
  onClickedSuccess: () => void;
  email: string;
}) => {
  const pathname = usePathname();
  const { formatMessage } = useIntl();
  const { addNotification } = useNotification();
  const doSubscribeNewsletterGql = useSubscribeNewsletterGqlMutation();

  const onSubmit = () =>
    doSubscribeNewsletterGql({
      formData: { email },
      areaKey: '',
      contextUri: pathname ?? '/',
    })
      .then(({ data: resultData, error: resultError }) => {
        if (resultError) {
          throw new Error(resultError.message);
        }
        if (
          resultData?.subscribeNewsletterRecipient &&
          'errors' in resultData.subscribeNewsletterRecipient &&
          resultData.subscribeNewsletterRecipient.errors &&
          resultData.subscribeNewsletterRecipient.errors.length > 0
        ) {
          throw new Error(formatMessage(generalFormMessages.errorApi));
        }
        onClickedSuccess();
      })
      .catch((error) => addNotification({ message: error.message, severity: 'error' }));
  return (
    <div>
      <p>{formatMessage(subscribeSheetMessages.doiText, { email })}</p>
      <button type="button" className="mt-2 underline" onClick={onSubmit}>
        <p>{formatMessage(subscribeSheetMessages.doiLink)}</p>
      </button>
    </div>
  );
};
